import { KyronClient } from '../components/utils/KyronClient';

export async function getMainCredentials() {
  const client = new KyronClient();
  return client.getDataWithError('/api/v1/main/get_credentials');
}
